import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Form, Typography, useAppSelector } from '../../../base';
import UserSettingsTabs from '../UserSettingsTabs';
import { StyledHeader } from './UserSettingsContent.styles';
import { useTranslation } from 'react-i18next';
import { defaultNotificationsSettingsFormValues } from '../../../common';
import { userSelectors } from '../../../actions';

interface IUserSettingsFormData {
    firstName: string;
    lastName: string;
    userEmail: string;
    userTitle: string;
    userGender: string;
    userPhoneNumber: string;
    userProfilePicture: string | File | null;
    notificationsSettings: Record<string, { sms: boolean; email: boolean }>;
}

export const UserSettingsContent = () => {
    const { t } = useTranslation();
    const myUser = useAppSelector(userSelectors.getMyUser);

    const methods = useForm<IUserSettingsFormData>({
        defaultValues: {
            firstName: '',
            lastName: '',
            userEmail: '',
            userTitle: '',
            userGender: '',
            userPhoneNumber: '',
            userProfilePicture: null,
            notificationsSettings: defaultNotificationsSettingsFormValues,
        },
    });

    const { control, handleSubmit, reset } = methods;

    useEffect(() => {
        if (myUser) {
            reset({
                firstName: myUser.firstName || '',
                lastName: myUser.lastName || '',
                userEmail: myUser.email || '',
                userTitle: myUser.jobTitle || '',
                userGender: myUser.gender || '',
                userPhoneNumber: myUser.phone || '',
                userProfilePicture: myUser.profilePicture || null,
                notificationsSettings: defaultNotificationsSettingsFormValues,
            });
        }
    }, [myUser, reset]);

    const onSubmit = (_data: IUserSettingsFormData) => {
        // TODO: connect to backend
    };

    return (
        <>
            <StyledHeader>
                <Typography variant="h4">
                    {t('userSettings.title')}
                </Typography>
                <Box>
                    <Button variant="outlined" sx={{ mr: 2 }}>
                        {t('userSettings.cancel')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                    >
                        {t('userSettings.save')}
                    </Button>
                </Box>
            </StyledHeader>
            <Form methods={methods} onSubmit={onSubmit}>
                <UserSettingsTabs control={control} />
            </Form>
        </>
    );
};
